/* eslint-disable no-useless-escape */
const cardHotelList = {
  props: {
    dynamicClass: ".c-card-hotel-list.dynamicLoading",
    targetSelector: "mod--card-hotel-target",
    targetCookieName: "ux_rp1_cp",
    targetCookieNameSt3: "ux_rp3_cp",
    targetCookieBooking: "booking_step_data",
    servletSelector: "targetselector",
    stepVersion: null,
    redirectUrl: null,
    finalRedirectUrl: null,
    lang: null,
    redirectCurrency: null,
    step3currency: null,
    defaultCurrency: "EUR",
  },
  componentSelectors: {
    hotelName: "c-card-hotel__content-header-title",
    hotelImg: "cmp-image__image",
    hotelDes: "c-card-hotel__content-header-location-link-txt",
    checkInSelector: "c-card-hotel__content_checkin",
    checkOutSelector: "c-card-hotel__content_checkout",
    roomsSelector: "c-card-hotel__content-body-search-room-number",
    adultsSelector: "c-card-hotel__content-body-search-people-adults",
    childSelector: "c-card-hotel__content-body-search-people-children",
    priceSelector: "c-price__value",
    redirectButton: "c-card-hotel-btn-target",
    ribbon1: "c-card-hotel-list-r1",
    ribbon3: "c-card-hotel-list-r3",
    priceText: "c-card-hotel-btn-claim",
  },
  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-cardHotelList.css", this.props.dynamicClass);

    if (document.querySelector("." + this.props.targetSelector)) {
      this.props.$container = document.querySelector("." + this.props.targetSelector);
      const bookingStep = this.targetGetCookie(this.props.targetCookieBooking);
      if (bookingStep && bookingStep === "3") {
        const step3 = this.targetGetCookie(this.props.targetCookieNameSt3);
        if (step3) {
          this.props.redirectUrl = this.targetGetCookie(this.props.targetCookieNameSt3);
          this.props.stepVersion = "3";
          this.targetConfig();
        }
      }
      if (bookingStep && (bookingStep === "1" || bookingStep === "2")) {
        const step1 = this.targetGetCookie(this.props.targetCookieName);
        if (step1) {
          this.props.redirectUrl = this.targetGetCookie(this.props.targetCookieName);
          this.props.stepVersion = "1";
          this.targetConfig();
        }
      }
    } else {
      const components = document.querySelectorAll(".c-card-hotel-list__wrapper");
      bcl.u.forEach(components, function ($component) {
        $component.setAttribute("data-swiper", "carouselOnlyMobile");
        $component.setAttribute("data-swiper-node", "true");
      });
    }
  },

  targetConfig: function () {
    const cookieBERedirectSearch = new URLSearchParams(this.props.redirectUrl);
    const hotelID = cookieBERedirectSearch.get("hotel");

    if (this.props.stepVersion === "3") {
      this.props.step3currency = cookieBERedirectSearch.get("bookingcurrency");
    }

    //GET LANGUAJE
    let lang = this.props.$container.dataset.lang.slice(-5);
    if (!lang.includes("es-es") && lang.includes("-")) {
      lang = lang.replace("-", "_");
    }
    this.props.lang = lang;

    this.prepareCookieValues(cookieBERedirectSearch);

    if (this.props.url == null) {
      this.props.url = document.querySelector("." + this.props.targetSelector).dataset.churl;
    }

    //MODIFY PATH TO CALL SERVLET
    this.props.url = this.props.url.replace("json", "bcldata." + this.props.servletSelector + "." + hotelID + "." + lang + ".json");

    if (hotelID) {
      bcl.ajax.getRequest(null, this.props.url, this.cardHotelCallback.bind(this));
    }
    this.prepareRedirectPath();

    // Check if the image is the default one and replace it with the correct one
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.checkImageURL.bind(this), false);
    } else {
      this.checkImageURL();
    }
  },

  checkImageURL: function () {
    const img = document.querySelector("." + this.props.targetSelector).querySelector("." + this.componentSelectors.hotelImg);
    const parentCmpSrc = img.parentElement.dataset?.cmpSrc;

    if (img.src.includes("/default") && parentCmpSrc && !parentCmpSrc.includes("/default")) {
      img.src = parentCmpSrc;
    }
  },

  cardHotelCallback: function (response) {
    if (response.response) {
      const obj = JSON.parse(response.response);
      document.querySelector("." + this.componentSelectors.hotelName).innerHTML = obj.map.hotelName;

      //MODIFY URL IMAGE
      const regex = /\/([^\/]+)\.jpg$/;
      const match = obj.map.image.match(regex);
      const imageName = match[1];
      const imageURL = "https://s7g10.scene7.com/is/image/barcelo/" + imageName + "?qlt=60&fmt=avif-alpha&cache=on&defaultImage=default-dm";

      document.querySelector("." + this.props.targetSelector).querySelector("." + this.componentSelectors.hotelImg).parentElement.dataset.cmpSrc = imageURL;

      document.querySelector("." + this.props.targetSelector).querySelector("." + this.componentSelectors.hotelImg).src = imageURL;
      if (obj.map.region != null) {
        if (obj.map.country != null) {
          document.querySelector("." + this.componentSelectors.hotelDes).innerHTML = obj.map.region + ", " + obj.map.country;
        } else {
          document.querySelector("." + this.componentSelectors.hotelDes).innerHTML = obj.map.region;
        }
      } else {
        document.querySelector(".c-card-hotel__content-header-location-link").classList.add("hidden");
      }

      // Verificar si `searchTags` existe
      if (obj.map.searchTags != null && this.props.stepVersion === "1") {
        const targetThemeElement = document.querySelector(".c-card-hotel-list-r1 .target-theme");
        const theme = targetThemeElement ? targetThemeElement.getAttribute("data-theme") : null;

        // Verificar si el valor de `data-theme` está en `searchTags`
        if (theme && obj.map.searchTags.includes(theme)) {
          // Mostrar target-theme y ocultar target-ribbon
          const targetRibbonElement = document.querySelector(".c-card-hotel-list-r1 .target-ribbon");

          if (targetRibbonElement) {
            targetRibbonElement.classList.add("hidden"); // Ocultar target-ribbon
          }
          targetThemeElement.classList.remove("hidden"); // Mostrar target-theme
        }
      }
    }
  },

  prepareRedirectPath: function () {
    if (document.body.dataset.currency != null) {
      this.props.redirectCurrency = document.body.dataset.currency;
    } else {
      if (this.props.step3currency != null) {
        this.props.redirectCurrency = this.props.step3currency;
      } else {
        this.props.redirectCurrency = this.props.defaultCurrency;
      }
    }

    if (this.props.stepVersion === "1") {
      this.props.finalRedirectUrl = this.props.redirectUrl + "&bookingcurrency=" + this.props.redirectCurrency + "&int=home-rp1";
    } else {
      document
        .querySelector("." + this.props.targetSelector)
        .querySelector(".c-card-hotel-btn-st1")
        .classList.add("hidden");
      document
        .querySelector("." + this.props.targetSelector)
        .querySelector(".c-card-hotel-btn-st3")
        .classList.remove("hidden");
      document
        .querySelector("." + this.props.targetSelector)
        .querySelector("." + this.componentSelectors.priceText)
        .classList.remove("hidden");

      this.props.finalRedirectUrl = this.props.redirectUrl + "&int=home-rp3";
    }

    const button = document.querySelector("." + this.props.targetSelector).querySelector("." + this.componentSelectors.redirectButton);
    if (button) {
      button.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(this.props.finalRedirectUrl);
      };
    }
  },

  prepareCookieValues: function ($el) {
    const checkin = this.refactorDate($el.get("arrive"));
    const checkout = this.refactorDate($el.get("depart"));
    const rooms = $el.get("rooms");
    const parents = $el.get("totaladults");
    const children = $el.get("totalchilds") !== null && $el.get("totalchilds") !== undefined ? $el.get("totalchilds") : 0;
    const price = $el.get("bookingprice");

    document.querySelector("." + this.componentSelectors.checkInSelector).innerHTML = checkin;
    document.querySelector("." + this.componentSelectors.checkOutSelector).innerHTML = checkout;
    document.querySelector("." + this.componentSelectors.roomsSelector).innerHTML = rooms;

    const adultsContent = document.querySelector("." + this.componentSelectors.adultsSelector).textContent.substring(3);
    document.querySelector("." + this.componentSelectors.adultsSelector).innerHTML = parents + adultsContent;

    const childsContent = document.querySelector("." + this.componentSelectors.childSelector).textContent.substring(3);
    document.querySelector("." + this.componentSelectors.childSelector).innerHTML = children + childsContent;

    if (this.props.stepVersion === "3") {
      document.querySelector(".c-price-normal-myb-JS").classList.remove("hidden");
      document.querySelector("." + this.componentSelectors.ribbon3).classList.remove("hidden");
      document.querySelector("." + this.props.targetSelector).querySelector("." + this.componentSelectors.priceSelector).innerHTML = price;
    } else {
      document.querySelector("." + this.componentSelectors.ribbon1).classList.remove("hidden");
    }
  },

  targetGetCookie: function (cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  refactorDate: function (date) {
    const slash = "/";
    let dateRefactor;
    dateRefactor = [date.slice(0, 4), slash, date.slice(4)].join("");
    dateRefactor = [dateRefactor.slice(0, 7), slash, dateRefactor.slice(7)].join("");
    const dateFormated = this.formatDate(dateRefactor);
    return dateFormated;
  },

  formatDate: function (date) {
    const d = new Date(date),
      year = d.getFullYear();
    let month = "" + (d.getMonth() + 1),
      day = "" + d.getDate();

    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }
    const htmlLang = document.documentElement.lang || "es";
    if (htmlLang.toLowerCase() === "en-us") {
      return [month, day, year].join("-");
    } else {
      return [day, month, year].join("-");
    }
  },

  formatPaxes: function (paxes, position) {
    paxes = paxes.split(",");
    return paxes[position];
  },
};

export default cardHotelList;
